<div
        class="container-notify"
        (click)="handleOpenModal()"
>
    <mat-icon
            matBadge=''
            *ngIf="totalNotification == 0"
            matBadgeColor="warn"
            aria-hidden="false"
            fontIcon="notifications">notifications
    </mat-icon>

    <mat-icon
            [matBadge]="totalNotification + ''"
            *ngIf="totalNotification != 0"
            matBadgeColor="warn"
            aria-hidden="false"
            fontIcon="notifications">notifications
    </mat-icon>
</div>


<div class="back" *ngIf="showModal" (click)="handleOpenModal()">
    <div
            [ngClass]="!mensagens.length ? 'modal-reduced' : 'modal'"
            *ngIf="showModal"
    >
        <div class="modal-content">
            <div class="notification-message-default" *ngIf="!mensagens.length">
                <p>Não há notificações.</p>
            </div>
            <div [ngClass]="
      notification.statusNotification === false
        ? 'notification-message notification-message-not-reader'
        : 'notification-message'
    "
                 *ngFor="let notification of mensagens">
                <div class="conteudo">
                    <div class="info">
                      <div class="reader" *ngIf="notification.statusNotification === true">
                        <i class="material-icons">
                          done_all
                        </i>
                      </div>
                      <div class="not-reader" *ngIf="notification.statusNotification === false">
                        <i class="material-icons">
                          done_all
                        </i>
                      </div>
                      <div class="created">
                        {{ notification.createdAt | date: 'HH:mm' }}
                      </div>
                    </div>
                    <p>{{ notification.mensagem }}</p>
                    <div class="action" (click)="handleDeleteNotification($event, notification)">
                        <i class="material-icons">
                            close
                        </i>
                    </div>
                </div>
            </div>

        </div>

    </div>
</div>

